var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElevatorPitchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_692",
    "data-name": "Group 692",
    transform: "translate(-370 -133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_617",
    "data-name": "Group 617",
    transform: "translate(79 -16)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    transform: "translate(291 149)",
    fill: "#18beb3",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_654",
    "data-name": "Group 654",
    transform: "translate(-3.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-megaphone",
    "data-name": "Icon ionic-md-megaphone",
    transform: "translate(381.068 139.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2652",
    "data-name": "Path 2652",
    d: "M16.977,10.948V5.625H15.341L10.432,9.716H3.886l-1.636.818v5.727l1.636.818,4.091,6.545h2.455L8.9,17.08h1.534l4.909,3.273h1.636V15.029a1.937,1.937,0,0,0,1.636-2.04A1.937,1.937,0,0,0,16.977,10.948Z",
    fill: "none",
    stroke: "#18beb3",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3226",
    "data-name": "Path 3226",
    d: "M-2648.166-3285.9s2.181,1.945,2.181,3.832-2.181,3.714-2.181,3.714",
    transform: "translate(3049 3435)",
    fill: "none",
    stroke: "#18beb3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3227",
    "data-name": "Path 3227",
    d: "M-2648.166-3288.253s3.619,3.244,3.619,6.175-3.619,5.546-3.619,5.546",
    transform: "translate(3051 3435)",
    fill: "none",
    stroke: "#18beb3",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevatorPitchIcon);
export default __webpack_public_path__ + "static/media/elevator-pitch-icon.3fca27e0d7f76cdbc14b57c9546d0a3c.svg";
export { ForwardRef as ReactComponent };